import type { PipeSpecification, ProcessSpecification } from "../models/types";

const parseMm = (raw: string | undefined | null): number | null => {
  if (!raw) return null;
  const match = raw.trim().match(/-?\d+(?:[.,]\d+)?/);
  if (!match) return null;
  const value = Number(match[0].replace(",", "."));
  return Number.isFinite(value) ? value : null;
};

/**
 * Single-side coating build-up (sheet F17 + 2×H17):
 *   nominal coating thickness + (plus tolerance × 2)
 */
export const calculateSingleSideCoatingBuildUpMm = (
  process: ProcessSpecification,
  pipe: PipeSpecification,
): number | null => {
  const nominal = parseMm(process.coatingThickness);
  if (nominal == null) return null;
  const plusTol = parseMm(pipe.coatingPlusTolerance) ?? 0;
  return nominal + plusTol * 2;
};

export const parseMeasureMm = parseMm;
